<template>
  <!-- Background Image -->
  <NuxtImg
    src="/hero-bg-watercolor-mobile.webp"
    alt="Hero Image"
    class="img-mobile block absolute inset-0 w-full h-full object-cover"
    decoding="async"
    loading="eager"
    fetchpriority="high"
    :preload="{
      fetchPriority: 'high',
    }"
  />

  <!-- Left Decoration -->
  <!-- Top -->
  <NuxtImg
    src="/hero-purple-decor-left-top-mobile.webp"
    alt="Hero Left Top Decoration"
    class="img-mobile absolute left-0 top-[15%] w-[160px] flower-sway flower-left wind-3 xsUp:w-[176px] sm:w-[192px]"
  />

  <!-- Bottom -->
  <NuxtImg
    src="/hero-purple-decor-left-bottom-mobile.webp"
    alt="Hero Left Bottom Decoration"
    class="img-mobile absolute bottom-0 left-0 w-3xs flower-sway flower-left wind-4 sm:w-2xs"
  />

  <!-- Right Decoration -->
  <!-- Top -->
  <NuxtImg
    src="/hero-purple-decor-right-top-mobile.webp"
    alt="Hero Right Top Decoration"
    class="img-mobile absolute right-0 top-[20%] w-[128px] flower-sway flower-right wind-5 xsUp:w-[160px] sm:w-[192px]"
  />
</template>
